// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MmN9hd6UQSICbHpIKKAs{margin-bottom:16px;padding-top:40px}.oaG7dqZc254c45xb1tnJ{margin-left:4px;text-decoration:none}.rm2eXyjuZBw6Ac1nZHpd{margin-top:24px}.HpUFxJyzvqkRUiRqJdBZ{background:var(--background-primary-inverted-primary);z-index:var(--zIndex-BASE_10);width:calc(100% + 28px);margin:0 -14px;padding:0 14px;position:-webkit-sticky;position:sticky;bottom:0}.o2jWoYectwtSskREoh0K>input:focus+div{outline:2px solid var(--content-brand-primary);outline-offset:2px}.UxXj9sJYAsMgOtcwDK9S{padding:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messagesCheckboxesWrap": `MmN9hd6UQSICbHpIKKAs`,
	"guidelinesLink": `oaG7dqZc254c45xb1tnJ`,
	"sampleMessageDesc": `rm2eXyjuZBw6Ac1nZHpd`,
	"stickyActions": `HpUFxJyzvqkRUiRqJdBZ`,
	"focusCheckbox": `o2jWoYectwtSskREoh0K`,
	"textField": `UxXj9sJYAsMgOtcwDK9S`
};
export default ___CSS_LOADER_EXPORT___;
